export default {
  notFound: 'Kayıt Bulunamadı',
};
